/**
 * Created by cbikar
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var CoAppInviteDropupViewController = require('web-agent-viewControllers/CoAppInviteDropupViewController');

    var CoAppInviteViewController = ViewController.extend({
        ControllerName: 'CoAppInviteViewController',

        LPViewMap: {
            cobrowse_dropup: '.lpview_cobrowse_dropup_button',
            voice_call_button: '.lpview_voice_invite_button',
            video_call_button: '.lpview_video_invite_button',
            cobrowse_button_content: '.lpview_cobrowse_dropup_content'
        },

        initialize: function (constructorData) {
            this.chatId = constructorData.chatId;
            this.visitorId = constructorData.visitorId;
            this.getConfig();
            this.initView();
            this.asyncMessaging = lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId);

            this.updateCapabilites();
        },

        events: function () {
            agentLEManager.onLEEvent("lpCoBrowseController:Notification", this.onCoAppNotification, this);
            agentLEManager.onLEEvent("lpCoBrowseController:ApiSupports", this.onApiSupports, this);

            this.bindViewEvent({
                selector: this.LPViewMap.cobrowse_dropup,
                DOMEvent: "click",
                callback: this.toggleCoBrowseMenu
            });
            this.bindViewEvent({
                selector: this.LPViewMap.voice_call_button,
                DOMEvent: "click",
                callback: this.onVoiceClicked
            });
            this.bindViewEvent({
                selector: this.LPViewMap.video_call_button,
                DOMEvent: "click",
                callback: this.onVideoClicked
            });
            this.bindViewEvent({
                selector: this.LPViewMap.cobrowse_button_content,
                DOMEvent: "blur",
                callback: this.hideDropup,
                ignoreChildBlur: true,
                includeSelf: true
            });


            this.updateChatId(this.chatId);
        },

        render: function () {

            if (!this.hasCoBrowseSharedPermission && !this.hasCoBrowseViewPermission) {
                this.lpHide(this.LPViewMap.cobrowse_dropup);
            }

            if (!this.hasVideoPermission) {
                this.lpHide(this.LPViewMap.video_call_button);
            }

            if (!this.hasVoicePermission) {
                this.lpHide(this.LPViewMap.voice_call_button);
            }

            this.updateButtonState();

        }
    });

    CoAppInviteViewController.prototype.getConfig = function () {
        this.hasCoBrowseViewPermission = lpTag.WebAgent.logicController.hasCoBrowseFeature();
        this.hasCoBrowseSharedPermission = lpTag.WebAgent.logicController.hasCoBrowseFeature();
        this.hasVoicePermission = lpTag.WebAgent.logicController.hasLiveVoiceFeature();
        this.hasVideoPermission = lpTag.WebAgent.logicController.hasLiveVideoFeature();

        if (lpTag.WebAgent.logicController.hasProfileFeature()) {
            this.hasCoBrowseViewPermission = this.hasCoBrowseViewPermission &&
                (privilegesController.hasCoBrowseViewOnlyPrivilege() ||
                privilegesController.hasCoBrowseViewOnlyWithScrollPrivilege());

            this.hasCoBrowseSharedPermission = this.hasCoBrowseSharedPermission && privilegesController.hasCoBrowseSharedPrivilege();

            this.hasVoicePermission = this.hasVoicePermission && privilegesController.hasLiveVoicePrivilege();
            this.hasVideoPermission = this.hasVideoPermission && privilegesController.hasLiveVideoPrivilege();
        } else {
            // check in SiteSettings. Can be removed once all accounts are migrated to Agent Profiles
            this.hasCoBrowseViewPermission = this.hasCoBrowseViewPermission && LE.siteSettings.cobrowseSettings.appEngagement.isPresetEnabled("COBROWSE_VIEWONLY");
            this.hasCoBrowseSharedPermission = this.hasCoBrowseSharedPermission && LE.siteSettings.cobrowseSettings.appEngagement.isPresetEnabled("COBROWSE_SHARED");

            this.hasVoicePermission = this.hasVoicePermission && LE.siteSettings.cobrowseSettings.appEngagement.isPresetEnabled("VOICE_CALL");
            this.hasVideoPermission = this.hasVideoPermission && LE.siteSettings.cobrowseSettings.appEngagement.isPresetEnabled("VIDEO_CALL");
        }

    };

    CoAppInviteViewController.prototype.sendInvite = function (mode) {
        if (this.isCoAppServiceEnabled()) {
            var params = {
                serviceId: lpTag.WebAgent.coBrowseController.generateServiceId(this.visitorId, this.chatId),
                chatId: this.chatId,
                visitorId: this.visitorId,
                mode: mode,
                engagementType: 'app'
            };

            lpTag.WebAgent.coBrowseController.createServiceId(params);
        }
    };

    CoAppInviteViewController.prototype.updateChatId = function (chatId) {
        if (chatId) {
            this.chatId = chatId;
            this.asyncMessaging = lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId);
        }
    };

    CoAppInviteViewController.prototype.initView = function () {
        var template = require('web-agent-templates/LP_coapp_invite_button.html');
        // var template = lpUtils.loadResource('web-agent-templates/LP_coapp_invite_button.html');
        this.createView({template: template});
        this.visible = false;

        if (this.hasCoBrowseSharedPermission || this.hasCoBrowseViewPermission) {
            createCoBrowseInviteButton(this);
        }

        function createCoBrowseInviteButton(context) {
            context.coAppInviteDropupView = new CoAppInviteDropupViewController({
                inviteOptions: {
                    view: context.hasCoBrowseViewPermission,
                    shared: context.hasCoBrowseSharedPermission
                },
                onCoBrowseShared: function () {
                    if (context.isCoAppServiceEnabled() && context.isCoBrowseSupported) {
                        context.sendInvite.call(context, "shared");
                        context.hideDropup();
                    }

                },
                onCoBrowseView: function () {
                    var viewOnlyProfile = "view";
                    if (lpTag.WebAgent.logicController.hasProfileFeature() &&
                        privilegesController.hasCoBrowseViewOnlyPrivilege() &&
                        !privilegesController.hasCoBrowseViewOnlyWithScrollPrivilege()) {

                        viewOnlyProfile = "follow";
                    }
                    if (context.isCoAppServiceEnabled() && context.isCoBrowseSupported) {
                        context.sendInvite.call(context, viewOnlyProfile);
                        context.hideDropup();
                    }
                }
            });
            context.addViewController({
                viewController: context.coAppInviteDropupView,
                target: context.LPViewMap.cobrowse_button_content
            });
        }

    };

    CoAppInviteViewController.prototype.onVideoClicked = function () {
        if (this.isCoAppServiceEnabled() && this.isVideoSupported) {
            this.sendInvite("VIDEO_CALL");
        }
    };

    CoAppInviteViewController.prototype.onVoiceClicked = function () {
        if (this.isCoAppServiceEnabled() && this.isVoiceSupported) {
            this.sendInvite("VOICE_CALL");
        }
    };

    CoAppInviteViewController.prototype.updateButtonState = function () {
        var cobrowse_dropup_button = this.getFirstElement(this.LPViewMap.cobrowse_dropup);
        var video_button = this.getFirstElement(this.LPViewMap.video_call_button);
        var voice_button = this.getFirstElement(this.LPViewMap.voice_call_button);

        if (this.isCoAppServiceEnabled() && this.isCoBrowseSupported) {
            this.removeClass(cobrowse_dropup_button, 'disabled');
        } else {
            this.addClass(cobrowse_dropup_button, 'disabled');
        }

        if (this.isCoAppServiceEnabled() && this.isVideoSupported) {
            this.removeClass(video_button, 'disabled');
        } else {
            this.addClass(video_button, 'disabled');
        }

        if (this.isCoAppServiceEnabled() && this.isVoiceSupported) {
            this.removeClass(voice_button, 'disabled');
        } else {
            this.addClass(voice_button, 'disabled');
        }
    };

    CoAppInviteViewController.prototype.onCoAppNotification = function (message) {
        if (message && message.data && message.data.state) {
            this.updateButtonState();
        }
    };

    CoAppInviteViewController.prototype.updateCapabilites = function () {
        var supportedCapabilities = lpTag.WebAgent.coBrowseController.getSupportedCapabilities() || {};
        this.isCoBrowseSupported = supportedCapabilities.COBROWSE;
        this.isVideoSupported = supportedCapabilities.VIDEO_CALL;
        this.isVoiceSupported = supportedCapabilities.VOICE_CALL;

        this.updateButtonState();
    };

    CoAppInviteViewController.prototype.onApiSupports = function () {
        this.updateCapabilites();
    };

    CoAppInviteViewController.prototype.isCoAppServiceEnabled = function () {
        return lpTag.WebAgent.coBrowseController.canSendInvite() &&
            (lpTag.WebAgent.logicController.hasCoBrowseFeature() ||
            lpTag.WebAgent.logicController.hasLiveVideoFeature() ||
            lpTag.WebAgent.logicController.hasLiveVoicePrivilege());
    };

    CoAppInviteViewController.prototype.hideDropup = function () {
        this.lpHide(this.LPViewMap.cobrowse_button_content);
        this.visible = false;
    };

    CoAppInviteViewController.prototype.showDropup = function () {
        if (this.isCoAppServiceEnabled()) {
            this.lpShow(this.LPViewMap.cobrowse_button_content);
            this.visible = true;
            this.focus(this.LPViewMap.cobrowse_button_content);
        }
    };

    CoAppInviteViewController.prototype.toggleCoBrowseMenu = function () {
        if (!this.visible) {
            this.showDropup();
        } else {
            this.hideDropup();
        }

    };

    return CoAppInviteViewController;

});
